export default __webpack_public_path__ + "static/media/logo-light.b45c1d8d.png";